import { render, staticRenderFns } from "./cardRanking.vue?vue&type=template&id=3264d23c&scoped=true"
import script from "./cardRanking.vue?vue&type=script&lang=js"
export * from "./cardRanking.vue?vue&type=script&lang=js"
import style0 from "./cardRanking.vue?vue&type=style&index=0&id=3264d23c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3264d23c",
  null
  
)

export default component.exports